import doctorClinicJoinPromptStore from "../../stores/DoctorClinicJoin/doctorClinicJoinPromptStore";

/**
 * Opens the confirmation dialog for creating a NEW doctor↔clinic association and
 * resolves to `true` (user confirmed — proceed to link) or `false` (cancel).
 *
 * Call this in the Rx dialogs right before the existing
 * `handleAssociateDoctorToClinic` call, i.e. when a resolved (existing) doctor
 * is not yet linked to the currently selected clinic.
 */
export function confirmDoctorClinicJoin(doctorData: any, clinic: any): Promise<boolean> {
  const c = doctorData?.contactInfo || {};
  const doctorName = [c.salutation, c.firstNames, c.lastName].filter(Boolean).join(" ").trim();

  return doctorClinicJoinPromptStore.requestConfirm({
    doctorName,
    doctorLANR: doctorData?.LANR || "",
    clinicName: clinic?.contactInfo?.businessName || "",
    clinicBSNR: clinic?.BSNR || "",
  });
}
